// jsQR video loop adapted from https://cozmo.github.io/jsQR/ by way of the
// cyfs kiosk app's BarcodeBase.jsx, minus the kiosk-only concerns.
import React, { Component } from 'react';
import jsQR from 'jsqr';
import beep from '../../assets/audio/beep';

const RESCAN_DELAY_MS = 3000;

class BarcodeScanner extends Component {

    canvasRef = null;
    videoRef = null;
    stream = null;
    rafId = null;

    // last decoded value + when, so a code held in frame fires once
    lastCode = null;
    lastCodeAt = 0;

    state = {
        loaded: false,
        outputMessage: 'Camera unavailable — check webcam permissions, or search by name below.',
    };

    componentDidMount() {

        this.videoRef = document.createElement('video');

        if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
            return;
        }

        // environment = rear camera on phones/tablets; laptops fall back to
        // whatever camera exists since this is not an "exact" constraint
        navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
        .then(stream => {
            this.stream = stream;
            this.videoRef.srcObject = stream;
            this.videoRef.setAttribute('playsinline', true); // no fullscreen takeover on iOS
            this.videoRef.play();
            this.setState({ outputMessage: 'Starting camera...' });
            this.rafId = window.requestAnimationFrame(this.tick);
        })
        .catch(e => console.warn(e.message));
    }

    componentWillUnmount() {
        if (this.rafId !== null) {
            window.cancelAnimationFrame(this.rafId);
        }
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
        }
    }

    tick = () => {

        if (!this.canvasRef) {
            return;
        }

        if (this.videoRef.readyState === this.videoRef.HAVE_ENOUGH_DATA) {

            if (!this.state.loaded) {
                this.setState({ loaded: true, outputMessage: '' });
            }

            this.canvasRef.height = this.videoRef.videoHeight;
            this.canvasRef.width = this.videoRef.videoWidth;

            const canvas = this.canvasRef.getContext('2d', { willReadFrequently: true });
            canvas.drawImage(this.videoRef, 0, 0, this.canvasRef.width, this.canvasRef.height);
            const imageData = canvas.getImageData(0, 0, this.canvasRef.width, this.canvasRef.height);

            const code = jsQR(imageData.data, imageData.width, imageData.height, {
                inversionAttempts: 'dontInvert',
            });

            if (code !== null && code.data.length > 0 && !this.props.disabled) {

                const now = Date.now();
                const rescan = code.data === this.lastCode && (now - this.lastCodeAt) < RESCAN_DELAY_MS;
                this.lastCode = code.data;
                this.lastCodeAt = now;

                if (!rescan) {
                    // catch: browsers block audio until the user has
                    // interacted with the page (login click covers it)
                    beep.play().catch(() => {});
                    this.props.onScan(code.data);
                }
            }
        }

        this.rafId = window.requestAnimationFrame(this.tick);
    }

    render() {

        const { loaded, outputMessage } = this.state;

        return (
            <div className="BarcodeScanner" style={{ textAlign: 'center' }}>
                <canvas
                    ref={ref => { this.canvasRef = ref; }}
                    style={{
                        display: loaded ? 'inline-block' : 'none',
                        width: '100%',
                        maxWidth: 400,
                    }}
                ></canvas>
                {outputMessage.length > 0 &&
                    <div className="outputMessage">{outputMessage}</div>
                }
            </div>
        );
    }
}

export default BarcodeScanner;
